import React, { FunctionComponent } from 'react';

import {
    LoadingSpinner,
    makeFullModal,
    useSafeIntl,
    AlertModal,
} from 'bluesquare-components';

import { useGetPolioNotificationImport } from '../hooks/api';
import MESSAGES from '../messages';
import { Task } from '../types';
import { NotificationImportDetailButton } from './NotificationImportDetailButton';

type Props = {
    task: Task<any>;
    isOpen: boolean;
    closeDialog: () => void;
};

const NotificationImportDetailModal: FunctionComponent<Props> = ({
    task,
    isOpen,
    closeDialog,
}) => {
    const { formatMessage } = useSafeIntl();

    const {
        data: notificationImport,
        isFetching: isFetchingNotificationImport,
    } = useGetPolioNotificationImport(task.polio_notification_import_id);

    return (
        <AlertModal
            isOpen={isOpen}
            closeDialog={closeDialog}
            titleMessage={formatMessage(
                MESSAGES.polioNotificationImportDetails,
            )}
            id="polio-notifications-import-details-modal"
            maxWidth="md"
        >
            {isFetchingNotificationImport && <LoadingSpinner />}
            {!isFetchingNotificationImport && (
                <>
                    <p>{task.result.message}</p>
                    {notificationImport &&
                        notificationImport.errors.length > 0 && (
                            <>
                                <p>
                                    {formatMessage(
                                        MESSAGES.polioNotificationImportErrors,
                                        {
                                            count: notificationImport.errors
                                                .length,
                                        },
                                    )}
                                </p>
                                <pre style={{ maxHeight: '550px' }}>
                                    {JSON.stringify(
                                        notificationImport.errors,
                                        null,
                                        ' ',
                                    )}
                                </pre>
                            </>
                        )}
                </>
            )}
        </AlertModal>
    );
};

const modalWithIconButton = makeFullModal(
    NotificationImportDetailModal,
    NotificationImportDetailButton,
);

export { modalWithIconButton as NotificationImportDetailModal };
